// Escrow/title companies offered on the Listing Agent LOI and the PSA.
//
// VALUE is the full escrow-agent designation a contract names - company, office
// address, attention line, phone and email - and is what the PSA's Earnest Money
// paragraph prints. SHORT is the company on its own, for the places a contract
// names the title company without its whole address (the PSA's title-company
// receipt line). LABEL is the picker's own display text.
export default [
    {
        VALUE:'Benchmark Title –2007 Randall St. Dallas, TX 75201 Attn: Greg Garza – P: 214-485-8638 E:ggarza@bmktitle.com',
        SHORT:'Benchmark Title',
        LABEL:'Benchmark - Dallas, TX - Greg Garza'
    },{
        VALUE:'Capital Title – 8333 Douglas Avenue Suite 1525, Dallas, Texas 75225 Attn: Bob Blanshard – P: 214-396-8071 E: BBlanshard@ctot.com',
        SHORT:'Capital Title',
        LABEL:'Capital Title - Dallas, TX - Bob Blanshard'
    },{
        VALUE:'Fidelity National Title –1125 Executive Circle, Suite 220, Irving, TX 75038 Attn: Billy Thomas – P: 817-829-5008 E: billy.thomas@fnf.com',
        SHORT:'Fidelity National Title',
        LABEL:'Fidelity - Irving, TX - Billy Thomas'
    },{
        VALUE:'Fidelity National Title - 1125 Executive Circle, Suite 220 Irving, TX 75038 Attn: Amanda Brower – P: 972-435-4330 E: Amanda.brower@fnf.com',
        SHORT:'Fidelity National Title',
        LABEL:'Fidelity - Irving, TX - Amanda Brower'
    },{
        VALUE:'Fidelity National Title - 3100 West 7th St, Suite 230 Fort Worth, TX 76107 Attn: Morgan Cofer - P: (817) 784-4990 E: morgan.cofer@fnf.com',
        SHORT:'Fidelity National Title',
        LABEL:'Fidelity - Fort Worth, TX - Morgan Cofer'
    },{
        VALUE:'Kensington Vanguard - 5005 LBJ Freeway Suite 200 Dallas, TX 75244 Attn Phil Prounh –  P: 817.807.7197 E: Pprounh@kvnational.com',
        SHORT:'Kensington Vanguard',
        LABEL:'Kensington - Dallas, TX - Phil Prounh'
    },{
        VALUE:'Madison Title - 13101 Preston Road Suite 300, Dallas TX 75240 Attn: Samuel Herskovits – P: (214) 461-4817 E: SHerskovits@madisontitle.com',
        SHORT:'Madison Title',
        LABEL:'Madison - Dallas, TX - Samuel Herskovits'
    },{
        VALUE:'Old Republic - 4200 Westheimer Road, Suite 150 Houston, Texas 77027 Attn: Harry Klein – P: (713) 482-2809 E: hklein@oldrepublictitle.com',
        SHORT:'Old Republic',
        LABEL:'Old Republic - Houston, Texas - Harry Klein'
    },{
        VALUE:'Other',
        SHORT:'',
        LABEL:'Other'
    }
]
